module.exports = __webpack_public_path__ + "static/img/iconwechat.92367df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iconwechat.jpg
// module id = 1Tz2
// module chunks = 1